<script>

import CommonService from '../../services/common'

export default {
    components: { 
         },
    props: ['field', 'value', 'modelValue', 'disabled', 'api', 'sortField', 'name', 'localized', 'disableStore', 'staticOptions'],
    emits: ['update:modelValue'],
    data(){
        return {
            selectedItems: [],
            options: []
        }
    },
    mounted(){
        this.loadOptions();
    },
    computed: {
        // options(){
        //     let store = this.disableStore ? this.staticOptions : this.$store.state.masterData[this.name];
        //     return store;
        // }
    },
    watch: {
        selectedItems(e){
            this.$emit('update:modelValue', e);
        },
        modelValue(e){
            this.selectedItems = e;
        }
    },
    methods: {
        loadOptions(){
            this.options = [];
            let params = {}
            if(this.sortField){
                params = {
                    sort: JSON.stringify([{property: this.sortField, direction: 'asc'}])
                };
            }

            let payload = {
                params: params,
                name: this.name,
                api: this.api
            };
            CommonService.loadGeneric(payload.api, payload.params, response => {
                if(response.success){
                    this.options = response.data;
                }
            })
        }
    }
}


</script>


<template>
    <DataTable :value="options" v-model:selection="selectedItems" :disabled="this.disabled" dataKey="value" responsiveLayout="scroll" >
        <Column selectionMode="multiple" headerStyle="width: 3em"></Column>
        <Column v-for="col of field.columns" :field="col.label" :header="$t(col.label)" :key="col.label" :style="{width:'150px'}" >
            <template #body="element">
                <span v-if="col.type == 'string'">
                    {{ element.data[col.name] }}
                </span>
                <span v-else-if="col.type == 'html'" v-html="element.data[col.name]">
                </span>
                <span v-else>
                    {{element.data[col.name]}}
                </span>
            </template>
        </Column>
    </DataTable>
</template>